// @flow
// Polymorphic functions without a specific type

import { isObject } from './type';
import { complement } from './function';

// Applies to arrays, strings, and nulls
export const isEmpty = (s: ?mixed): boolean =>
  s
    ? typeof s === 'string' ||
      Array.isArray(s) ||
      (isObject(s) && 'length' in s)
      ? s.length === 0
      : (() => {
          throw new Error('got unexpected value in isEmpty');
        })()
    : true;

// Applies to arrays, strings, and nulls
export const isNotEmpty: (?mixed) => boolean = complement(isEmpty);
